import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ApContentModule } from '@ap/content';
import { ApContentComponentsModule } from '@ap/content-components';
import { ApDarkmodeModule } from '@ap/darkmode';

@NgModule({
    imports: [ApContentComponentsModule, ApContentModule, ApDarkmodeModule, BrowserModule],
    exports: [ApContentComponentsModule, ApContentModule, ApDarkmodeModule, BrowserModule]
})
export class BaseStarterAppModule {}
